export const SET_MENU_ITEM_DATA = 'SET_MENU_ITEM_DATA';
export const TOGGLE_MODIFIERS_FORM = 'TOGGLE_MODIFIERS_FORM';
export const TOGGLE_MODIFIER_GROUPS_FORM = 'TOGGLE_MODIFIER_GROUPS_FORM';
export const TOGGLE_MENU_ITEM_FORM = 'TOGGLE_MENU_ITEM_FORM';
export const CREATE_MODIFIER_GROUP = 'CREATE_MODIFIER_GROUP';
export const UPDATE_MODIFIER_GROUP = 'UPDATE_MODIFIER_GROUP';
export const CREATE_MODIFIER = 'CREATE_MODIFIER';
export const UPDATE_MODIFIER = 'UPDATE_MODIFIER';
export const UPDATE_MENU_ITEM = 'UPDATE_MENU_ITEM';